import { create } from "zustand";
import type { IqueryForExecutionSummaryHistorical } from "@/services/ActionSummaryTableSERVICES";

// LQC-1885 - scoped by cryptoID so the widget header and right-click menu can see
// the blotter's historical search, which was previously local grid state.
export const DEFAULT_HISTORICAL_SEARCH: IqueryForExecutionSummaryHistorical = {
  shortStartDate: "",
  shortEndDate: "",
  historicTradeDataForDataRange: [],
  viewingHistoricalTable: false,
};

type HistoricalSearchUpdate =
  | IqueryForExecutionSummaryHistorical
  | ((
      prev: IqueryForExecutionSummaryHistorical,
    ) => IqueryForExecutionSummaryHistorical);

type HistoricalSearchState = {
  searchByCryptoId: { [cryptoID: string]: IqueryForExecutionSummaryHistorical };
  setHistoricalSearch: (cryptoID: string, update: HistoricalSearchUpdate) => void;
  endHistoricalSearch: (cryptoID: string) => void;
  clearHistoricalSearch: (cryptoID: string) => void;
};

export function returnHistoricalSearch(
  searchByCryptoId: HistoricalSearchState["searchByCryptoId"],
  cryptoID: string,
): IqueryForExecutionSummaryHistorical {
  return searchByCryptoId[cryptoID] ?? DEFAULT_HISTORICAL_SEARCH;
}

const historicalSearchStore = create<HistoricalSearchState>()((set) => ({
  searchByCryptoId: {},
  setHistoricalSearch: (cryptoID, update) =>
    set((state) => {
      const prev = returnHistoricalSearch(state.searchByCryptoId, cryptoID);
      const next = typeof update == "function" ? update(prev) : update;
      return { searchByCryptoId: { ...state.searchByCryptoId, [cryptoID]: next } };
    }),
  endHistoricalSearch: (cryptoID) =>
    set((state) => {
      const prev = returnHistoricalSearch(state.searchByCryptoId, cryptoID);
      return {
        searchByCryptoId: {
          ...state.searchByCryptoId,
          [cryptoID]: { ...prev, viewingHistoricalTable: false },
        },
      };
    }),
  clearHistoricalSearch: (cryptoID) =>
    set((state) => {
      const { [cryptoID]: _removed, ...rest } = state.searchByCryptoId;
      return { searchByCryptoId: rest };
    }),
}));

export default historicalSearchStore;
